import { render } from "./ConsistencyAnalysis.vue?vue&type=template&id=478c19a9"
import script from "./ConsistencyAnalysis.vue?vue&type=script&lang=js"
export * from "./ConsistencyAnalysis.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__